"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cookie_helper_1 = require("../helpers/cookie-helper");
var navbar_display_1 = require("../navbar/navbar-display");
var login_modal_helper_1 = require("../helpers/login-modal-helper");
var Auth = (function () {
    function Auth(api) {
        this._4hours = 4000;
        this._api = api;
        this._navbar = new navbar_display_1.default();
    }
    Auth.prototype.login = function (user) {
        var self = this;
        this._api.send('/login', { 'username': user.username, 'password': user.password }, function (response) {
            if (!response.Data) {
                login_modal_helper_1.default.logErorr(response.ErrorText);
            }
            else {
                var now = new Date();
                var time = now.getTime();
                time += 3600 * self._4hours;
                now.setTime(time);
                document.cookie = 'uName=' + response.Data.AuthUserResponse[0]['Username'] + ';path=/; expires=' + now.toUTCString();
                document.cookie = 'token=' + response.Data.AuthUserResponse[0]['SessionID'] + ';path=/; expires=' + now.toUTCString();
                document.cookie = 'currency=' + response.Data.AuthUserResponse[0]['Currency'] + ';path=/; expires=' + now.toUTCString();
                self._navbar.showLogedIn(user, response);
                login_modal_helper_1.default.closeModal();
                window['token'] = response.Data.AuthUserResponse[0]['SessionID'];
                var getTickets = new CustomEvent("get_tickets_no_stats");
                window.dispatchEvent(getTickets);
            }
        }, function (reject) {
            login_modal_helper_1.default.logErorr('Login failed.');
            console.log('Login failed.' + JSON.parse(reject));
        });
    };
    Auth.prototype.logout = function () {
        var username = cookie_helper_1.default.get('uName');
        var self = this;
        this._api.send('/logout', { 'username': username }, function (response) {
            var now = new Date();
            var time = now.getTime();
            time -= 3600 * self._4hours;
            now.setTime(time);
            if (!response.Data) {
                document.cookie = 'uName=' + username + ';path=/; expires=' + now.toUTCString();
                document.cookie = 'token=' + window['token'] + ';path=/; expires=' + now.toUTCString();
                document.cookie = 'currency=' + cookie_helper_1.default.get('currency') + ';path=/; expires=' + now.toUTCString();
                self._navbar.showLogedOut();
                var getTickets = new CustomEvent("get_tickets_no_stats");
                window.dispatchEvent(getTickets);
                window.dispatchEvent(window['loggedOut']);
            }
        }, function () {
            console.log('Logout failed.');
        });
    };
    return Auth;
}());
exports.default = Auth;



//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/ts/auth/auth.ts
// module id = 1211
// module chunks = 0